import React from "react";

const Chicken = props => (
  <svg viewBox="0 0 100 100" {...props}>
    <g fill="none" opacity={0.4}>
      <circle fillOpacity={0.8} fill="#4A4A4A" cx={50} cy={50} r={50} />
      <path
        d="M75.826 37.135L16.092 69.849l30.005 30c1.288.1 2.59.151 3.903.151 24.1 0 44.215-17.05 48.946-39.745l-23.12-23.12z"
        fill="#4A4A4A"
      />
      <path
        d="M22.055 53.569c0 12.56 18.383 16.245 36.551 16.245 18.168 0 21.93-6.934 21.93-19.494 0-12.56-7.417-19.494-25.585-19.494S22.055 41.008 22.055 53.569z"
        fill="#682421"
      />
      <path
        d="M17.688 31.278l7.345 5.354 1.785-2.448-7.345-5.354a3.03 3.03 0 1 0-5.46-2.105 3.03 3.03 0 1 0 3.674 4.553z"
        fill="#F0DEB4"
      />
      <path
        d="M54.95 30.826c-1.526 0-3.029.074-4.5.213v38.506c2.68.185 5.42.269 8.156.269 18.168 0 21.93-6.934 21.93-19.494 0-12.56-7.417-19.494-25.585-19.494z"
        fill="#5B1D1D"
      />
      <path
        d="M43.521 36.987c4.057 2.956 2.75 6.88-.208 10.937-2.957 4.056-6.445 6.71-10.502 3.753-4.056-2.956-12.292-13.997-9.334-18.053 2.957-4.057 15.988.405 20.044 3.363z"
        fill="#823733"
      />
      <path
        d="M66.36 60.486c0-3.589 3.437-5.513 7.679-5.513 4.24 0 7.68 1.924 7.68 5.513 0 3.59-3.439 6.498-7.68 6.498-4.242 0-7.68-2.909-7.68-6.498zm-44.305 0c0-3.589 3.438-5.513 7.68-5.513 4.24 0 7.679 1.924 7.679 5.513 0 3.59-3.438 6.498-7.68 6.498-4.241 0-7.68-2.909-7.68-6.498z"
        fill="#C0392B"
      />
      <circle fill="#6AAC4B" cx={63.209} cy={62.652} r={1.772} />
      <circle fill="#6AAC4B" cx={56.317} cy={62.652} r={1.772} />
      <circle fill="#59913C" cx={59.27} cy={62.652} r={1.772} />
      <path
        d="M18.412 70.824h64.783a3.249 3.249 0 1 0 0-6.498H18.412a3.249 3.249 0 1 0 0 6.498z"
        fill="#F0DEB4"
      />
      <path
        d="M83.195 64.326H50.449v6.498h32.746a3.25 3.25 0 1 0 0-6.498z"
        fill="#D6C299"
      />
    </g>
  </svg>
);

export default Chicken;



// WEBPACK FOOTER //
// ./src/components/Icons/Chicken.js